export const BUSINESS_TRUSTPASS_FETCH_BEGIN = "BUSINESS_TRUSTPASS_FETCH_BEGIN";
export const BUSINESS_TRUSTPASS_FETCH_SUCCESS = "BUSINESS_TRUSTPASS_FETCH_SUCCESS";
export const BUSINESS_TRUSTPASS_FETCH_FAILURE = "BUSINESS_TRUSTPASS_FETCH_FAILURE";

export const BUSINESS_TRUSTPASS_UPDATE_SUCCESS = "BUSINESS_TRUSTPASS_UPDATE_SUCCESS";
export const BUSINESS_TRUSTPASS_HYDRATE = "BUSINESS_TRUSTPASS_HYDRATE";
export const BUSINESS_TRUSTPASS_DOCUMENT_UPDATE = "BUSINESS_TRUSTPASS_DOCUMENT_UPDATE";
export const BUSINESS_TRUSTPASS_STATUS_UPDATE = "BUSINESS_TRUSTPASS_STATUS_UPDATE";

export const PERSONAL_TRUSTPASS_STATUS_UPDATE = "PERSONAL_TRUSTPASS_STATUS_UPDATE";

export const PERSONAL_TRUSTPASS_DOCUMENT_UPDATE = "PERSONAL_TRUSTPASS_DOCUMENT_UPDATE";

export const TRUSTPASS_RESOLVE_NOTIFICATIONS = "TRUSTPASS_RESOLVE_NOTIFICATIONS";



// WEBPACK FOOTER //
// ./src/features/trustpass/actionTypes.js